module.exports = __webpack_public_path__ + "img/ej-logo-baseline.f7dccc20.jpg";